import axios from 'axios';
import { BiasApiResponse, DailyBias, BiasDetailApiResponse } from '../interfaces';

export const fetchBiasData = async (): Promise<BiasApiResponse> => {
  const response = await axios.get<BiasApiResponse>('https://api.diwo.capital/v1/bias');
  
  return {
    data: response.data.data,
    total: response.data.total,
    timestamp: response.data.timestamp
  };
};

export const fetchBiasDetail = async (id: number): Promise<DailyBias> => {
  const response = await axios.get<BiasDetailApiResponse>(`https://api.diwo.capital/v1/bias/${id}`);
  return response.data.data;
};